export const firmsPlural = {
    ru: {
        zero: 'фирм',
        one: 'фирма',
        few: 'фирмы',
        many: 'фирм',
        other: 'фирм'
    },
    en: {
        zero: 'companies',
        one: 'company',
        few: 'companies',
        many: 'companies',
        other: 'companies'
    }
};

export const firmsAccusativeCasePlural = {
    ru: {
        zero: 'фирм',
        one: 'фирму',
        few: 'фирмы',
        many: 'фирм',
        other: 'фирм'
    },
    en: {
        zero: 'companies',
        one: 'company',
        few: 'companies',
        many: 'companies',
        other: 'companies'
    }
};



